import { combineReducers } from 'redux';
import { Api } from '../../../core/api';

const userInfoApi = new Api({
  namespace: 'ADMIN_USER_INFO',
  useEagleApi: true,
});

export const fetchUserInfo = (id: string) =>
  userInfoApi.fetch({
    url: `/internal-intranet/users/${id}`,
  });

export const resetUserInfo = userInfoApi.reset;

const userUpdateApi = new Api({
  namespace: 'ADMIN_USER_UPDATE',
  options: {
    method: 'PUT',
  },
  useEagleApi: true,
});

export const updateUser = (id: string, user: any) =>
  userUpdateApi.fetch({
    options: {
      body: JSON.stringify(user),
    },
    url: `/internal-intranet/users/${id}`,
  });

export const reducer = combineReducers({
  userInfo: userInfoApi.reducer,
  userUpdate: userUpdateApi.reducer,
});
